import { CashMovementList, CashMovementResponse, CashSessionList, CashSessionResponse, CurrentCashSessionResponse, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * `/api/v1/cash` — as sessões de caixa e os terminais.
 *
 * Todo valor viaja como string, no formato de máquina (ADR-0016). Repare no
 * que NENHUMA destas funções manda: o valor esperado. O fechamento manda o que
 * foi CONTADO; o servidor deriva o resto do razão, e não existe campo no
 * contrato que pudesse carregar outra coisa.
 */
/**
 * Every amount crossing this boundary is a string, in the machine format.
 *
 * The till form parses what a person typed — `1.234,56` — with @aeris/money and
 * serialises the exact value here. A JSON number would be rounded by the
 * browser before the request was even built. ADR-0016.
 *
 * Note what none of these functions sends: an expected amount. The close sends
 * what was COUNTED; the server derives the rest from the ledger, and there is
 * no field in the contract that could carry anything else.
 */
export const fetchCashSessions = async (query, signal) => {
    const params = new URLSearchParams();
    if (query.branchId !== undefined)
        params.set('branchId', query.branchId);
    if (query.status !== undefined)
        params.set('status', query.status);
    if (query.page !== undefined)
        params.set('page', String(query.page));
    if (query.pageSize !== undefined) {
        params.set('pageSize', String(query.pageSize));
    }
    if (query.sort !== undefined)
        params.set('sort', query.sort);
    if (query.direction !== undefined)
        params.set('direction', query.direction);
    const encoded = params.toString();
    return CashSessionList.parse(await request(`/api/v1/cash/sessions${encoded.length > 0 ? `?${encoded}` : ''}`, { signal }));
};
/** Null when no till is open at the terminal — the ordinary start-of-shift state. */
export const fetchCurrentCashSession = async (query, signal) => {
    const params = new URLSearchParams({ terminalId: query.terminalId });
    if (query.branchId !== undefined)
        params.set('branchId', query.branchId);
    return CurrentCashSessionResponse.parse(await request(`/api/v1/cash/sessions/current?${params.toString()}`, {
        signal,
    }));
};
export const fetchCashMovements = async (sessionId, signal, order) => {
    const params = new URLSearchParams({ pageSize: '100' });
    if (order?.page !== undefined)
        params.set('page', String(order.page));
    if (order?.sort !== undefined)
        params.set('sort', order.sort);
    if (order?.direction !== undefined)
        params.set('direction', order.direction);
    return CashMovementList.parse(await request(`/api/v1/cash/sessions/${sessionId}/movements?${params.toString()}`, { signal }));
};
export const openCashSession = async (input) => CashSessionResponse.parse(await request('/api/v1/cash/sessions', { method: 'POST', body: input }));
export const recordCashMovement = async (sessionId, input) => CashMovementResponse.parse(await request(`/api/v1/cash/sessions/${sessionId}/movements`, {
    method: 'POST',
    body: input,
}));
export const closeCashSession = async (sessionId, input) => CashSessionResponse.parse(await request(`/api/v1/cash/sessions/${sessionId}/close`, {
    method: 'POST',
    body: input,
}));
//# sourceMappingURL=cash.js.map